
import actionLogSagas from 'store/action-log/saga'
import analyticsSagas from 'store/analytics/saga'
import authSagas from 'store/auth/saga'
import billingSagas from 'store/billing/saga'
import certificatesSagas from 'store/certificates/saga'
import customersSagas from 'store/customers/saga'
import ownersSagas from 'store/owners/saga'

import scanSessionSagas from 'store/scan-session/saga'
import shopSagas from 'store/shop/saga'
import tagsSagas from 'store/tags/saga'
import themeSagas from 'store/theme/saga'
import usersSagas from 'store/users/saga'

import { all } from 'redux-saga/effects'

import installationsSaga from './installations/saga'


export default function* rootSaga(): Generator {
  yield all([...authSagas])
  yield all([...certificatesSagas])
  yield all([...billingSagas])
  yield all([...shopSagas])
  yield all([...customersSagas])
  yield all([...ownersSagas])
  yield all([...actionLogSagas])
  yield all([...analyticsSagas])
  yield all([...themeSagas])
  yield all([...usersSagas])
  yield all([...scanSessionSagas])
  yield all([...tagsSagas])
  yield all([...installationsSaga])
}
